import React from 'react';
import { useContextParams } from '@core/params/context';
import { CustomProductPriceStyleWrapper } from '@core/shopping/components/CustomFonts';
import { useProductPrice } from '@core/shopping/hooks/useProductPrice';
import { PRODUCT_PRICE_LABEL } from '@player/testIds';
import { OverflowWrapper } from './PriceLabel.styles';
import { UnitPriceLabel } from './UnitPriceLabel';
/**
 *
 */
export const PriceLabel = ({ product, fontSize, originalPriceFontSize, gapBetweenPrices, forceUnitPrice, unit, modifierFn, }) => {
    const params = useContextParams();
    const isHideProductPriceFeatureEnabled = Boolean(params?.hide_product_price);
    const productPriceWithCurrency = useProductPrice({
        product,
        modifierFn,
    });
    const shouldHideProductPrice = Boolean(product.product_hide_price);
    if (isHideProductPriceFeatureEnabled && shouldHideProductPrice) {
        return null;
    }
    // Clients would like to show the strike through price if there is only 1 unit with original price.
    // https://fwn.atlassian.net/browse/GROW-626
    if (product.product_units.length === 1 || forceUnitPrice) {
        return (<UnitPriceLabel unit={forceUnitPrice
                ? unit ?? product.product_units[0]
                : product.product_units[0]} currency={product.product_currency} fontSize={fontSize} originalPriceFontSize={originalPriceFontSize} gapBetweenPrices={gapBetweenPrices} modifierFn={modifierFn}/>);
    }
    return (<OverflowWrapper>
      <CustomProductPriceStyleWrapper fontSize={fontSize} data-testid={PRODUCT_PRICE_LABEL}>
        {productPriceWithCurrency}
      </CustomProductPriceStyleWrapper>
    </OverflowWrapper>);
};
